import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { ShareIcon } from '@lean-body/components/atoms';
export const ShareButton = ({ classObject, onClick }) => {
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement(ShareIcon, { classObject: styles.shareIcon, color: Colors.CyanLightest, onClick: onClick })));
};
const styles = StyleSheet.create({
    container: {
        background: 'rgba(30, 32, 32, 0.15)',
        width: 26,
        height: 26,
        borderRadius: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
    shareIcon: {
        width: 12,
        height: 13,
        margin: 5,
    },
});
